import { render, staticRenderFns } from "./doctorAttachment.vue?vue&type=template&id=79458966&scoped=true&"
import script from "./doctorAttachment.vue?vue&type=script&lang=js&"
export * from "./doctorAttachment.vue?vue&type=script&lang=js&"
import style0 from "./doctorAttachment.vue?vue&type=style&index=0&id=79458966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79458966",
  null
  
)

export default component.exports